import { CONTACTS } from 'constants/Entities';
import BASE_CONFIG from 'containers/contacts/TableConfig';
import { getMarketingStatusColumn } from 'components/TableCells/MarketingStatusCell/column';
import { setMarketingConsentContact } from 'services/MarketingConsentService';

const ALLOWED_COLS = ['nombre', 'apellidos', 'empresa', 'email'];

export default ({ onClickCheckbox, spamchimp, canEdit } = {}) => {
    const tableParams = {
        ...(onClickCheckbox ? { contact: { onClickCheckbox } } : {}),
        spamchimp,
        ...(canEdit !== undefined ? { canEdit } : {}),
    };
    const base = BASE_CONFIG(tableParams);
    const filterKey = spamchimp ? 'subscribersContacts_v2' : 'subscribersContacts';
    const quickFilters = spamchimp
        ? ['marketingStatus', ...base.quickFilters.filter((id) => id !== 'marketingStatus')]
        : base.quickFilters.filter((id) => id !== 'marketingStatus');

    const marketingColumn = spamchimp
        ? [
              getMarketingStatusColumn({
                  minWidth: 160,
                  entity: CONTACTS,
                  setMarketingConsent: setMarketingConsentContact,
              }),
          ]
        : [];

    return {
        ...base,
        filterKey,
        quickFilters,
        columnSelectorSections: undefined,
        withEntitySelection: true,
        selectionFor: CONTACTS.entity,
        isLocalSelection: true,
        columnDefs: [
            ...base.columnDefs
                .filter((col) => ALLOWED_COLS.includes(col.colId))
                .map(({ width, suppressSizeToFit, ...col }) => ({ ...col, minWidth: width })),
            ...marketingColumn,
        ],
    };
};
